<template>
  <div class="search-content">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'ExameCenterLayout',
    data () {
      return {
        tabs: {
          items: [
            {
              key: '1',
              title: '星级俱乐部'
            },
            {
              key: '4',
              title: '俱乐部升级'
            },
            {
              key: '7',
              title: '俱乐部建设升级'
            },
            {
              key: '2',
              title: '俱乐部建设订单'
            },
            {
              key: '3',
              title: '俱乐部建设商品'
            },
            {
              key: '5',
              title: '俱乐部积分申请'
            },
            {
              key: '6',
              title: '俱乐部话题'
            },
          ],
          active: () => {
            switch (this.$route.path) {
              case '/club/ClubList':
                return '1'
              case '/club/ClubJiansheList':
                return '2'
              case '/club/ClubJiansheGradeList':
                return '7'
              case '/club/ClubGoodsList':
                return '3'
              case '/club/ClubGradeList':
                return '4'
              case '/club/ClubScoreApplyList':
                return '5'
              case '/club/ClubTopicList':
                return '6'
              default:
                return '1'
            }
          },
          callback: (key) => {
            switch (key) {
              case '1':
                this.$router.push('/club/ClubList')
                break
              case '2':
                this.$router.push('/club/ClubJiansheList')
                break
              case '3':
                this.$router.push('/club/ClubGoodsList')
                break
              case '4':
                this.$router.push('/club/ClubGradeList')
                break
              case '5':
                this.$router.push('/club/ClubScoreApplyList')
                break
              case '6':
                this.$router.push('/club/ClubTopicList')
                break
              case '7':
                this.$router.push('/club/ClubJiansheGradeList')
                break
              default:
                this.$router.push('/workplace')
            }
          }
        },
        search: false
      }
    },
    computed: {

    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  .search-head{
    background-color: #fff;
    margin: -25px -24px -24px;
    .search-input{
      text-align: center;
      margin-bottom: 16px;
    }
  }
  .search-content{
    margin-top: 0px;
  }
</style>
